import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getBacking, startBacking } from "@/lib/studioApi";
import { safeApiError } from "@/lib/safeErrorText";

const POLL_MS = 3000;

/** A version's backing track (vocals split from the music) — start it, then poll until it's ready. */
export default function useBacking(project, version) {
  const [backing, setBacking] = useState(version.backing || null);
  const [busy, setBusy] = useState(false);
  const running = backing?.status === "running";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => getBacking(project.id, version.id).then(setBacking).catch(() => null), POLL_MS);
    return () => clearInterval(t);
  }, [running, project.id, version.id]);
  const prepare = async () => {
    setBusy(true);
    try { setBacking(await startBacking(project.id, version.id)); }
    catch (e) { toast.error("Couldn't start the backing track", { description: safeApiError(e) }); }
    finally { setBusy(false); }
  };
  return { backing, prepare, busy };
}
